import React from "react";
import HeaderAdmin from "../header/header";
import SwapComponent from "../../Swap/SwapComponent";

const SwapTokenPage = () => {
  return (
    <>
      <HeaderAdmin />
      <div>
        <SwapComponent />
      </div>
    </>
  );
};

export default SwapTokenPage;
